import { type FunctionComponent } from "react";

import { Container, PlaceholderBar } from "./styles";

export type AbWidgetPlaceholderProps = {
  className?: string;
};

/**
 * Shared placeholder shown during SSR and before client-side data resolves.
 * Used for all 4 widget areas (SCMP Series, Open Question, CFT, Spotlight).
 */
export const AbWidgetPlaceholder: FunctionComponent<AbWidgetPlaceholderProps> = ({ className }) => (
  <Container className={className}>
    <PlaceholderBar $height={20} $width="40%" />
    <PlaceholderBar $height={14} $width="100%" />
    <PlaceholderBar $height={14} $width="100%" />
    <PlaceholderBar $height={14} $width="80%" />
  </Container>
);

AbWidgetPlaceholder.displayName = "AbWidgetPlaceholder";
